export const useSpecialCards = () => {

  const bgColors = [
    '#005b41',
    '#7a1cac',
    '#da0d81',
    '#4d3bcf',
    '#028170',
    '#ad49e1',
    '#4b70f5',
    '#940b92',
    '#fedb5b',
    '#3dc2ec',
    '#d21212',
    '#e6d2aa',
    '#d36b01',
    '#ed2b29',
    '#08d003',
    '#f0a500',
    '#e45726',
    '#9bec00',
    '#ffaf61',
  ]

  function getSpecialBgColor(index: number) {
    return bgColors[index % bgColors.length]
  }

  return {
    getSpecialBgColor,
  }
}